import type { ReactNode } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal.ts';
import { Footer } from './Footer.tsx';
import { Nav } from './Nav.tsx';
import { ScrollTop } from './ScrollTop.tsx';

/**
 * Shared page chrome: skip link, nav, main landmark, footer, scroll-to-top.
 *
 * The scroll-reveal observer is registered here — once per page — rather
 * than in each page, so there is exactly one IntersectionObserver per load.
 */
export function Layout({
  children,
  currentPath,
  navOnLight = false,
}: {
  children: ReactNode;
  currentPath: string;
  navOnLight?: boolean;
}) {
  useScrollReveal();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to main content
      </a>
      <Nav currentPath={currentPath} onLight={navOnLight} />
      <main id="main">{children}</main>
      <Footer />
      <ScrollTop />
    </>
  );
}
